module.exports = __webpack_public_path__ + "static/media/collaboration.21435688.png";